import { State } from "@progress/kendo-data-query";
import { GridFlavorEnum, GridFlavorModifiersEnum } from '../../enums/grid.enums';
export class GridParams {
    public kendoGridState: State;
    public gridFlavor: GridFlavorEnum;
    public gridFlavorModifier: GridFlavorModifiersEnum;

    constructor(kendoGridState: State, gridFlavor: GridFlavorEnum, gridFlavorModifier: GridFlavorModifiersEnum) {
        this.kendoGridState = kendoGridState;
        this.gridFlavor = gridFlavor;
        this.gridFlavorModifier = gridFlavorModifier;
    }
}
